var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "dashboard-text"
  }, [_c('img', {
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "src": require("../../../assets/oa/approve-back.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.closeBack()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("审批中心")])]), _vm._v(" "), (!_vm.detailShow) ? _c('div', {
    staticClass: "dashboard-content"
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "tab-wrap"
  }, _vm._l((_vm.tabList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "tab",
      class: _vm.tabIndex == index ? 'tabClass' : '',
      style: (index == 0 ? 'border-left:none' : ''),
      on: {
        "click": function($event) {
          return _vm.tabClick(index)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "tab-hr"
  })]), _vm._v(" "), _c('el-form', {
    staticStyle: {
      "position": "relative",
      "padding": "40px 0 0 46px"
    },
    attrs: {
      "inline": true,
      "model": _vm.condition
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "审批类型"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "203px",
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.condition.approval_process_type),
      callback: function($$v) {
        _vm.$set(_vm.condition, "approval_process_type", $$v)
      },
      expression: "condition.approval_process_type"
    }
  }, _vm._l((_vm.typeList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "dashboard-button",
    on: {
      "click": function($event) {
        return _vm.Find(_vm.tabIndex)
      }
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('section', [_c('el-table', {
    ref: "multipleTable",
    staticClass: "tableBox",
    staticStyle: {
      "width": "96%",
      "margin": "0 2%"
    },
    attrs: {
      "data": _vm.tableData,
      "header-cell-style": {
        'text-align': 'center',
        background: '#F0F0F0',
        color: '#000'
      },
      "cell-style": {
        'text-align': 'center'
      }
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "审批类型",
      "prop": "set_type"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "审批名称",
      "prop": "set_name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "提出时间",
      "prop": "proposed_time"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.state == 0) ? _c('img', {
          attrs: {
            "src": require("../../../assets/oa/approve-orange-round.png"),
            "alt": ""
          }
        }) : _vm._e(), _vm._v(" "), (scope.row.state == 2) ? _c('img', {
          attrs: {
            "src": require("../../../assets/oa/approve-red-round.png"),
            "alt": ""
          }
        }) : _vm._e(), _vm._v(" "), (scope.row.state == 1) ? _c('img', {
          attrs: {
            "src": require("../../../assets/oa/approve-green-round.png"),
            "alt": ""
          }
        }) : _vm._e()]
      }
    }], null, false, 2977961456)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "通过时间",
      "prop": "pass_time"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "dashboard-delDisplay"
        }, [_c('img', {
          attrs: {
            "src": require("../../../assets/oa/operate-approve.png"),
            "alt": ""
          },
          on: {
            "click": function($event) {
              return _vm.clickBtn('APPROVE', scope.row)
            }
          }
        }), _vm._v(" "), _c('img', {
          staticStyle: {
            "margin": "0 10px"
          },
          attrs: {
            "src": require("../../../assets/oa/operate-detail.png"),
            "alt": ""
          },
          on: {
            "click": function($event) {
              return _vm.clickBtn('DETAIL', scope.row)
            }
          }
        })])]
      }
    }], null, false, 2198919398)
  })], 1)], 1), _vm._v(" "), _c('section', {
    staticStyle: {
      "text-align": "center",
      "padding": "20px 0"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "page-size": _vm.page_size,
      "layout": " prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.detailShow == '1') ? _c('div', [_c('div', {
    staticClass: "dashboard-content",
    staticStyle: {
      "padding-bottom": "30px",
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "detail-wrap"
  }, [_c('span', {
    staticClass: "detail-title"
  }, [_vm._v(_vm._s(_vm.detailList.set_name))]), _vm._v(" "), (_vm.detailList.reviewer_state == 1) ? _c('img', {
    staticClass: "detail-img",
    attrs: {
      "src": require("../../../assets/oa/approve-green-square.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.detailList.reviewer_state == 0) ? _c('img', {
    staticClass: "detail-img",
    attrs: {
      "src": require("../../../assets/oa/approve-orange-square.png"),
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "detail-time"
  }, [_vm._v(_vm._s(_vm.detailList.reviewer_date))]), _vm._v(" "), (_vm.detailList.reviewer_state == 0) ? _c('div', {
    staticClass: "detail-button"
  }, [_c('el-button', {
    staticClass: "dashboard-button",
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.clickBtn('AGREE', '1')
      }
    }
  }, [_vm._v("同意")]), _vm._v(" "), _c('el-button', {
    staticClass: "dashboard-buttonWhite",
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.clickBtn('REJECT', '2')
      }
    }
  }, [_vm._v("驳回")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "detail-title-gray"
  }, [_vm._v("申请详情")]), _vm._v(" "), (_vm.detailList.form != null) ? _c('div', {
    staticClass: "dashboard-content",
    staticStyle: {
      "padding": "30px"
    }
  }, [_c('VFormReader', {
    ref: "vFormRef",
    staticClass: "form",
    attrs: {
      "form-json": _vm.formJson,
      "form-data": _vm.formData,
      "option-data": _vm.optionData
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.detailList.set_type == '19') ? _c('div', {
    staticClass: "dashboard-content",
    staticStyle: {
      "padding": "30px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("组织架构：")]), _c('span', [_vm._v(_vm._s(_vm.detailList.oaDetails.organizeName))])]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("项目名称：")]), _c('span', [_vm._v(_vm._s(_vm.detailList.oaDetails.project_name))])]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("金额：")]), _c('span', [_vm._v(_vm._s(_vm.detailList.oaDetails.money_amount))])]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("申请人：")]), _c('span', [_vm._v(_vm._s(_vm.detailList.oaDetails.applicantName))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("审批总监：")]), _c('span', [_vm._v(_vm._s(_vm.detailList.oaDetails.approval_director))])]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("预计付款时间：")]), _c('span', [_vm._v(_vm._s(_vm.detailList.oaDetails.estimate_payment_time))])]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("付款时间：")]), _c('span', [_vm._v(_vm._s(_vm.detailList.oaDetails.payment_time))])]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("未回款金额：")]), _c('span', [_vm._v(_vm._s(_vm.detailList.oaDetails.uncollected_payment))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("备注：")]), _c('span', [_vm._v(_vm._s(_vm.detailList.oaDetails.spare))])]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("最后操作时间：")]), _c('span', [_vm._v(_vm._s(_vm.detailList.oaDetails.modified_time))])])])]) : _vm._e(), _vm._v(" "), (_vm.detailList.set_type == '22') ? _c('div', {
    staticClass: "dashboard-content",
    staticStyle: {
      "padding": "30px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("组织架构：")]), _c('span', [_vm._v(_vm._s(_vm.detailList.oaDetails.organizeName))])]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("项目名称：")]), _c('span', [_vm._v(_vm._s(_vm.detailList.oaDetails.projectName))])]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("区域总管：")]), _c('span', [_vm._v(_vm._s(_vm.detailList.oaDetails.areaManagerName))])]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("金额：")]), _c('span', [_vm._v(_vm._s(_vm.detailList.oaDetails.money_amount))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("申请人：")]), _c('span', [_vm._v(_vm._s(_vm.detailList.oaDetails.applicantName))])]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("预计付款时间：")]), _c('span', [_vm._v(_vm._s(_vm.detailList.oaDetails.estimate_payment_time))])]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("付款时间：")]), _c('span', [_vm._v(_vm._s(_vm.detailList.oaDetails.payment_time))])]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("未回款金额：")]), _c('span', [_vm._v(_vm._s(_vm.detailList.oaDetails.uncollected_payment_money))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("是否撤场：")]), _c('span', [_vm._v(_vm._s(_vm.detailList.oaDetails.spare))])]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("收据情况：")]), _c('span', [_vm._v(_vm._s(_vm.detailList.oaDetails.is_receipt == '1' ? '有' : '无'))])]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("备注：")]), _c('span', [_vm._v(_vm._s(_vm.detailList.oaDetails.spare))])]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("最后操作时间：")]), _c('span', [_vm._v(_vm._s(_vm.detailList.oaDetails.modified_time))])])])]) : _vm._e(), _vm._v(" "), (_vm.detailList.set_type == '20') ? _c('div', {
    staticClass: "dashboard-content",
    staticStyle: {
      "padding": "30px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("项目名称：")]), _c('span', [_vm._v(_vm._s(_vm.detailList.oaDetails.projectName))])]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("金额：")]), _c('span', [_vm._v(_vm._s(_vm.detailList.oaDetails.amount))])])])]) : _vm._e(), _vm._v(" "), (_vm.detailList.set_type == '21') ? _c('div', {
    staticClass: "dashboard-content",
    staticStyle: {
      "padding": "30px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("项目名称：")]), _c('span', [_vm._v(_vm._s(_vm.detailList.oaDetails.projectName))])]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("金额：")]), _c('span', [_vm._v(_vm._s(_vm.detailList.oaDetails.amount))])])])]) : _vm._e(), _vm._v(" "), (_vm.detailList.set_type == '17' || _vm.detailList.set_type == '18') ? _c('div', {
    staticClass: "dashboard-content",
    staticStyle: {
      "padding": "30px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "margin-top": "20px"
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "header-cell-style": {
        background: '#d3eae2',
        color: '#000000'
      },
      "data": _vm.newdata,
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope_1) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(scope_1.$index + 1) + "\n\t\t\t\t\t\t\t")]
      }
    }], null, false, 407070737)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "projectName",
      "align": "center",
      "label": "项目名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "annual",
      "align": "center",
      "label": "预算年度目标数据汇总"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "annual",
      "align": "center",
      "label": "预算年度"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "annualTotalRevenue",
      "align": "center",
      "label": "年度总营收"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "annualTotalExpenditure",
      "align": "center",
      "label": "年度总支出"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "annualTotalProfit",
      "align": "center",
      "label": "年度税后总利润"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "annualTotalTax",
      "align": "center",
      "label": "年度税后"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "1月",
      "prop": "accumulate_1"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "2月",
      "prop": "accumulate_2"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "3月",
      "prop": "accumulate_3"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "4月",
      "prop": "accumulate_4"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "5月",
      "prop": "accumulate_5"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "6月",
      "prop": "accumulate_6"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "7月",
      "prop": "accumulate_7"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "8月",
      "prop": "accumulate_8"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "9月",
      "prop": "accumulate_9"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "10月",
      "prop": "accumulate_10"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "11月",
      "prop": "accumulate_11"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "12月",
      "prop": "accumulate_12"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticStyle: {
            "margin": "0 10px"
          },
          attrs: {
            "src": require("../../../assets/oa/operate-detail.png"),
            "alt": ""
          },
          on: {
            "click": function($event) {
              return _vm.clickBtn('DETAILTwo', scope.row)
            }
          }
        })]
      }
    }], null, false, 1195189426)
  })], 1)], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    staticClass: "modal",
    attrs: {
      "title": _vm.title,
      "visible": _vm.showDialog,
      "center": true,
      "width": _vm.width
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, _vm._l((_vm.approveList.oaExamineDetails), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "approve"
    }, [_c('div', {
      staticClass: "approve-left"
    }, [(item.reviewer_state == 1) ? _c('img', {
      staticClass: "approve-img",
      attrs: {
        "src": require("../../../assets/oa/flowPath-green.png"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (item.reviewer_state == 2) ? _c('img', {
      staticClass: "approve-img",
      attrs: {
        "src": require("../../../assets/oa/flowPath-red.png"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (item.reviewer_state == 0) ? _c('img', {
      staticClass: "approve-img",
      attrs: {
        "src": require("../../../assets/oa/flowPath-orange.png"),
        "alt": ""
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "position"
    }, [_c('div', {
      staticClass: "position-left"
    }, [_c('div', [_vm._v(_vm._s(item.staff_name))]), _vm._v(" "), _c('div', {
      class: item.reviewer_state == 0 ? 'orange' : item.reviewer_state == 1 ? 'green' : item.reviewer_state == 2 ? 'red' : 'blue'
    }, [(item.reviewer_state == 1) ? _c('span', [_vm._v("已同意")]) : _vm._e(), _vm._v(" "), (item.reviewer_state == 2) ? _c('span', [_vm._v("已驳回")]) : _vm._e(), _vm._v(" "), (item.reviewer_state == 0) ? _c('span', [_vm._v("待审批")]) : _vm._e()]), _vm._v(" "), (item.reviewer_state == 2) ? _c('div', {
      staticClass: "position-refuse"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t驳回原因：" + _vm._s(item.reject_reason) + "\n\t\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), (item.reviewer_state != 0) ? _c('div', {
      staticClass: "position-time"
    }, [_vm._v(_vm._s(item.reviewer_date))]) : _vm._e()])]), _vm._v(" "), (index != _vm.approveList.oaExamineDetails.length - 1) ? _c('div', {
      staticClass: "approve-hr"
    }) : _vm._e()])
  }), 0), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.status == '1' ? '同意原因' : '驳回原因',
      "visible": _vm.ShowAgreeReject,
      "width": "30%",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.ShowAgreeReject = $event
      }
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.form.reject_reason),
      callback: function($$v) {
        _vm.$set(_vm.form, "reject_reason", $$v)
      },
      expression: "form.reject_reason"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "background-color": "#006E4B",
      "border-color": "#006E4B"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.SaveAgreeReject(_vm.status)
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), (_vm.detailShow == '2') ? _c('detailPage', {
    attrs: {
      "detailMonetyId": _vm.detailMonetyId
    },
    on: {
      "closeBack2": _vm.closeBack2
    }
  }) : _vm._e()], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-078270e0","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/oa/approve/approveCenter.vue
// module id = null
// module chunks = 